import { type Dispatch, type SetStateAction } from 'react';
import styled from 'styled-components';
import {
    type MobilityApplicationEntrypointContextDataFragment,
    type PrefetchKycConsentsDataFragment,
} from '../../../../../api';
import { type KycFieldSpecsFragment } from '../../../../../api/fragments/KYCFieldSpecs';
import breakpoints from '../../../../../utilities/breakpoints';
import { type KYCPresetFormFields, type UploadDocumentProp } from '../../../../../utilities/kycPresets';
import { type AgreementValues } from '../../../../shared/CIPage/ConsentAndDeclarations/useAgreementsValues';
import { type GiftVoucherAction, type GiftVoucherState } from '../reducer';

export const leftColSpan = { xl: 8, lg: 12, md: 24, xs: 24 };
export const rightColSpan = { xl: 16, lg: 12, md: 24, xs: 24 };

export const Title = styled.h4`
    padding-top: 12px;
    padding-bottom: 12px;
    font-size: 20px;
    font-weight: 900;
`;

export const PurchaseDescription = styled.p`
    font-size: 16px;
    margin-bottom: 32px;
`;

export const StyledMarkdown = styled.div`
    margin-top: 20px;
`;
export const ApplicantKycContainer = styled.div`
    @media screen and (max-width: ${breakpoints.md}) {
        & .ant-pro-footer-bar {
            .ant-pro-footer-bar-right {
                width: 100%;
            }
        }
    }
`;

export type GiftVoucherKYCJourneyValues = {
    agreements: AgreementValues;
    customer: GiftVoucherPurchaserFormValues;
    isCorporateCustomer: boolean;
    hasGuarantor: boolean;
    prefix?: string;
    prefill: boolean;
    numberOfBookingReferenceDays: number;
    stockId?: string;
    value: number;
    variantSuiteId?: string;
    modelId?: string;
};

export type GiftVoucherPurchaserFormValues = {
    fields: KYCPresetFormFields;
};

export type GiftVoucherKYCPageProps = {
    state: GiftVoucherState;
    dispatch: Dispatch<GiftVoucherAction>;
    endpoint: MobilityApplicationEntrypointContextDataFragment;
};

export type GiftVoucherKYCInnerProps = GiftVoucherKYCPageProps &
    UploadDocumentProp & {
        giftVoucherKycPreset: KycFieldSpecsFragment[];
        setPrefill: Dispatch<SetStateAction<boolean>>;
        applicantPrefetch: { applicant?: PrefetchKycConsentsDataFragment };
        preFetchDataLoading: boolean;
        isDrafted: boolean;
    };
